var map = {
	"./arrow-right.svg": 3,
	"./calendar.svg": 4,
	"./chevron-right.svg": 5,
	"./clock.svg": 6,
	"./euro.svg": 7,
	"./facebook.svg": 8,
	"./heart.svg": 9,
	"./instagram.svg": 10,
	"./location.svg": 11,
	"./members.svg": 12,
	"./pin.svg": 13,
	"./pinterest.svg": 14,
	"./place.svg": 15,
	"./twitter.svg": 16,
	"./user.svg": 17,
	"./vimeo.svg": 18,
	"./youtube.svg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;